<template>
  <div>
    <div class="gr-section-wrapper gr-section-wrapper-lg-row" :style="paddingTop">
      <div>
        <img class="gr-main-img" :src="imgName" alt="Individuelle Anfertigung"
             v-on:load="imageDownloadFinished(1)">
      </div>
      <div class="gr-content-container gr-scrollable">
        <div class="gr-text-container gr-text-container-lg-column px-4 px-lg-5" :style="paddingY">
          <transition name="slide-fade" appear>
            <div id="gr-goldschmiede">
              <h1 class="gr-header-2">{{ title }}</h1>
              <div class="gr-p-container" v-reveal>
                <p v-html="text"></p>
              </div>
              <gr-btn-lite text="zurück" backgroundColor="rose" @click.native="$routeBack()"></gr-btn-lite>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="section fp-auto-height">
      <AppFooter backgroundColor="rose"></AppFooter>
    </div>
  </div>
</template>

<script>

import AppFooter from './../../layout/Footer'
import grBtnLite from '@/components/grBtnLite'
import { timeout } from '@/config'

export default {
  name: 'IndividuellesDetail',
  props: {
    title: { type: String },
    text: { type: String },
    imgName: { type: String }
  },
  components: {
    grBtnLite,
    AppFooter
  },
  data () {
    return {
      isNewLoading: true,
      isImageLoading1: true,
      imgContainerHeight: 0,
      textContainerHeight: 0,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.isNewLoading = true
    this.setLoading(true)
  },
  mounted () {
    document.body.style.height = 'auto'
    this.handleResize()
  },
  beforeMount () {
    this.isNewLoading = false
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    setTimeout(() => this.setLoading(false), 400)
  },
  beforeDestroy () {
    this.$store.commit('setHeader', true)
  },
  computed: {
    paddingTop () {
      if (this.isDesktop) {
        return { padding: '50px 0 0 0 !important' }
      } else {
        return { padding: Math.round(this.$store.getters['dom/navBarHeight'] - 3) + 'px 0 0 0 !important' }
      }
    },
    isDesktop: function () {
      return this.$store.getters['dom/isDesktop']
    },
    isLoading: function () {
      return !this.$store.getters['loading/isLoadingApp']
    },
    sectionHeight () {
      return this.isDesktop && { 'min-height': Math.max(Math.round(this.window.height - 50), document.getElementById('gr-goldschmiede')?.clientHeight + 60) + 'px !important' }
    },
    paddingY () {
      return !this.isDesktop && {
        'padding-top': '35px !important',
        'padding-bottom': '35px !important'
      }
    }
  },
  methods: {
    imageDownloadFinished (id) {
      this.isImageLoading1 = false
      setTimeout(() => {
        this.setLoading(false)
      }, timeout.smallTimeout)
    },
    setLoading (isLoaded) {
      this.$store.commit('loading/SET_LOADING_APP', isLoaded)
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      if (this.window.width < 992) {
        this.imgContainerHeight = this.window.height * 0.35
        this.textContainerHeight = (this.window.height - 80) * 0.65
      } else {
        this.imgContainerHeight = this.window.height * 0.40
        this.textContainerHeight = (this.window.height - 110) * 0.60
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    margin-bottom: 10px;
  }

  b {
    font-weight: 500;
  }

  .gr-section-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: $color-gr-rose;
  }
  .gr-content-container {
    padding-top: 15px;
  }
  .gr-text-container {
    line-height: 1.1;
  }
  .gr-p-container {
    margin-bottom: 0.5rem;
  }
  p {
    font-size: 0.95em;
    line-height: 1.7;
  }
  .gr-main-img {
    object-fit: cover;
    object-position: 50% 20%;
    width: 100%;
    height: 35vh;
  }
  @media(max-height: 820px) {
    .gr-scrollable {
      min-height: 60vh !important;
    }
  }

  @media(min-width: 760px) {
    .gr-text-container-lg-column {
      max-width: 80vw;
      // prevent that on transition potential image below text-container moves
      min-height: 25vh;
    }
    .gr-p-container {
      margin-bottom: 1rem;
    }
  }

  @media(min-width: 760px) and (max-width: 1025px) {
    .gr-text-container {
      max-width: 80vw !important;
      min-height: 25vh !important;
    }
  }

  @media(max-width: 1023px) {
    .gr-scrollable {
      min-height: 60vh !important;
    }
  }

  @media(min-width: $window-lg) {
    .gr-scrollable {
      height: 100vh;
    }
    .gr-text-container-lg-column {
      min-height: 35vh;
    }
    .gr-section-wrapper-lg-row {
      flex-direction: row;
      justify-content: flex-start;
    }
    p {
      font-size: 1.1em;
    }
    .gr-main-img {
      object-position: 50% 50%;
      width: 40vw;
      height: 100%;
      flex: 1;
    }
  }
</style>
